<div class="img-container">
  <u-icon [model]="{ type: 'img', value: emptyStateIcon }" [styles]="{}" [inSvg]="emptyStateIcon?.lightUrl"></u-icon>
</div>
<div class="title">Explore your network!</div>
<div class="subtitle">Type a topic to see who's working on it</div>
